// Zentrale Geschäftsdaten — eine Quelle für die ganze Seite.
// Telefon-/WhatsApp-Nummer werden hier zentral gepflegt.
export const BUSINESS = {
  name: "YOUR CUT",
  subtitle: "Herren Friseur Salon",
  owner: "Osman Arslan",

  // WhatsApp-/Telefon-Nummer (zentral). Stand: aktuelle Nummer des Salons.
  phone: "+49 163 7036972",
  phoneHref: "tel:+491637036972",
  whatsappHref:
    "https://wa.me/491637036972?text=Hallo%20YOUR%20CUT%2C%20ich%20habe%20eine%20Frage%3A%20",

  email: "hallo@yourcut-hamm.de",
  emailHref: "mailto:hallo@yourcut-hamm.de",

  address: "Hammer Steindamm 62, 20535 Hamburg",
  mapsEmbed:
    "https://www.google.com/maps?q=Hammer+Steindamm+62,+20535+Hamburg&output=embed",
  mapsLink: "https://maps.app.goo.gl/ccdN7orF93QmPcV39",
  rating: "4.7",
};

// Bildpfade. Liegen lokal im /public-Ordner und werden mit dem Build
// als statische Assets ausgeliefert — keine externen Abhängigkeiten,
// portabel für Alfahosting / klassisches Webhosting.
export const IMAGES = {
  hero: "/images/salon-team-wideshot.jpg",
  about: "/images/salon-beardtrim.jpg",
  gallery: [
    "/images/salon-shave-detail.jpg",
    "/images/salon-storefront-1.jpg",
    "/images/salon-storefront-2.jpg",
  ],
};
